import {ISystemStatus, IVersionControl} from '@/types/version-control';
import {create} from 'zustand';

type IUpcomingFlight = {
  date: string;
  flightNumber: string;
  departure: string;
  startDate: string;
  arrival: string;
  endDate: string;
  isUTC: boolean;
  crews: string[];
};

interface VersionControlState {
  appFailureStatus: ISystemStatus | null;
  setAppFailureStatus: (appFailureStatus: ISystemStatus) => void;
  refreshAppFailureStatus: number;
  setRefreshAppFailureStatus: (refreshAppFailureStatus: number) => void;
  versionControl: IVersionControl | null;
  setVersionControl: (versionControl: IVersionControl) => void;
  upcomingFlight: IUpcomingFlight | null;
  setUpcomingFlight: (upcomingFlight: IUpcomingFlight) => void;
}

const useVersionControlStore = create<VersionControlState>()((set) => ({
  appFailureStatus: null,
  setAppFailureStatus: (appFailureStatus: ISystemStatus) =>
    set(() => ({appFailureStatus})),
  refreshAppFailureStatus: 0,
  setRefreshAppFailureStatus: (refreshAppFailureStatus: number) => {
    set(() => ({refreshAppFailureStatus}));
  },
  versionControl: null,
  setVersionControl: (versionControl: IVersionControl) =>
    set(() => ({versionControl})),
  upcomingFlight: null,
  setUpcomingFlight: (upcomingFlight: IUpcomingFlight) =>
    set(() => ({upcomingFlight}))
}));

export default useVersionControlStore;
